/**
 * 产品规格演示数据 — 8 款来自 4 家竞品的真实 LED 产品参数
 * 用于知识树展示和产品库功能验证
 */
import type { PriceIntelProductSpec } from '../types';

export const demoProductSpecs: PriceIntelProductSpec[] = [
  {
    temp_id: 'demo-spec-001',
    model: 'Absen A27 Plus',
    competitor: 'Absen',
    series: 'A Series',
    pitch_mm: 2.7,
    led_type: 'SMD 2020',
    panel_width_mm: 500,
    panel_height_mm: 500,
    panel_depth_mm: 75,
    weight_kg: 7.5,
    max_power_w: 210,
    typical_power_w: 70,
    brightness: 5000,
    refresh_rate: 3840,
    ip_rating: 'IP65',
    viewing_angle: 'H160°/V160°',
    contrast_ratio: '5000:1',
    indoor_outdoor: 'Outdoor',
    maintenance: 'Front',
    material: 'Die-cast Aluminum',
    module_width_mm: 250,
    module_height_mm: 250,
    color_temperature: '3200–9300K',
    curve: null,
    application: 'Outdoor Fixed',
    spec_confidence: 0.92,
    spec_source: 'rule-engine',
    warnings: [],
  },
  {
    temp_id: 'demo-spec-002',
    model: 'Absen CL1.2',
    competitor: 'Absen',
    series: 'CL Series',
    pitch_mm: 1.27,
    led_type: 'COB',
    panel_width_mm: 600,
    panel_height_mm: 337.5,
    panel_depth_mm: 42,
    weight_kg: 5.2,
    max_power_w: 150,
    typical_power_w: 50,
    brightness: 800,
    refresh_rate: 3840,
    ip_rating: 'IP30',
    viewing_angle: 'H170°/V170°',
    contrast_ratio: '20000:1',
    indoor_outdoor: 'Indoor',
    maintenance: 'Front',
    material: 'Die-cast Aluminum',
    module_width_mm: 200,
    module_height_mm: 112.5,
    color_temperature: '3200–9300K',
    curve: null,
    application: 'Conference / Control Room',
    spec_confidence: 0.88,
    spec_source: 'rule-engine',
    warnings: [],
  },
  {
    temp_id: 'demo-spec-003',
    model: 'Leyard TVH1.2',
    competitor: 'Leyard',
    series: 'TVH Series',
    pitch_mm: 1.2,
    led_type: 'COB',
    panel_width_mm: 600,
    panel_height_mm: 337.5,
    panel_depth_mm: 39.5,
    weight_kg: 5.8,
    max_power_w: 160,
    typical_power_w: 55,
    brightness: 600,
    refresh_rate: 3840,
    ip_rating: 'IP30',
    viewing_angle: 'H176°/V176°',
    contrast_ratio: '20000:1',
    indoor_outdoor: 'Indoor',
    maintenance: 'Front',
    material: 'Die-cast Aluminum',
    module_width_mm: 200,
    module_height_mm: 112.5,
    color_temperature: '3200–9300K',
    curve: null,
    application: 'Control Room / Broadcast',
    spec_confidence: 0.95,
    spec_source: 'rule-engine',
    warnings: [],
  },
  {
    temp_id: 'demo-spec-004',
    model: 'Leyard VPH0.9',
    competitor: 'Leyard',
    series: 'VPH Series',
    pitch_mm: 0.93,
    led_type: 'MicroLED',
    panel_width_mm: 600,
    panel_height_mm: 337.5,
    panel_depth_mm: 38,
    weight_kg: 5.5,
    max_power_w: 120,
    typical_power_w: 40,
    brightness: 500,
    refresh_rate: 7680,
    ip_rating: 'IP30',
    viewing_angle: 'H176°/V176°',
    contrast_ratio: '100000:1',
    indoor_outdoor: 'Indoor',
    maintenance: 'Front',
    material: 'Die-cast Aluminum',
    module_width_mm: 150,
    module_height_mm: 168.75,
    color_temperature: '3200–9300K',
    curve: null,
    application: 'Command Center / Cinema',
    spec_confidence: 0.90,
    spec_source: 'rule-engine',
    warnings: [],
  },
  {
    temp_id: 'demo-spec-005',
    model: 'ROE BP2V2',
    competitor: 'ROE Visual',
    series: 'Black Pearl',
    pitch_mm: 2.84,
    led_type: 'SMD 2020',
    panel_width_mm: 500,
    panel_height_mm: 500,
    panel_depth_mm: 80,
    weight_kg: 8.0,
    max_power_w: 230,
    typical_power_w: 78,
    brightness: 5500,
    refresh_rate: 3840,
    ip_rating: 'IP65',
    viewing_angle: 'H160°/V160°',
    contrast_ratio: '5000:1',
    indoor_outdoor: 'Outdoor',
    maintenance: 'Front/Rear',
    material: 'Die-cast Aluminum',
    module_width_mm: 250,
    module_height_mm: 250,
    color_temperature: '3200–9300K',
    curve: null,
    application: 'Outdoor Rental / Fixed',
    spec_confidence: 0.85,
    spec_source: 'rule-engine',
    warnings: [],
  },
  {
    temp_id: 'demo-spec-006',
    model: 'ROE CB5',
    competitor: 'ROE Visual',
    series: 'Carbon',
    pitch_mm: 5.77,
    led_type: 'SMD 2727',
    panel_width_mm: 500,
    panel_height_mm: 1000,
    panel_depth_mm: 68,
    weight_kg: 7.5,
    max_power_w: 400,
    typical_power_w: 130,
    brightness: 6000,
    refresh_rate: 3840,
    ip_rating: 'IP65',
    viewing_angle: 'H160°/V160°',
    contrast_ratio: '5000:1',
    indoor_outdoor: 'Outdoor',
    maintenance: 'Rear',
    material: 'Carbon Fiber',
    module_width_mm: 250,
    module_height_mm: 250,
    color_temperature: '3200–9300K',
    curve: 'Lockable',
    application: 'Rental & Staging',
    spec_confidence: 0.91,
    spec_source: 'rule-engine',
    warnings: [],
  },
  {
    temp_id: 'demo-spec-007',
    model: 'INFiLED WP1.5',
    competitor: 'INFiLED',
    series: 'WP Series',
    pitch_mm: 1.56,
    led_type: 'GOB',
    panel_width_mm: 600,
    panel_height_mm: 337.5,
    panel_depth_mm: 40,
    weight_kg: 6.0,
    max_power_w: 170,
    typical_power_w: 56,
    brightness: 800,
    refresh_rate: 3840,
    ip_rating: 'IP40',
    viewing_angle: 'H170°/V170°',
    contrast_ratio: '10000:1',
    indoor_outdoor: 'Indoor',
    maintenance: 'Front',
    material: 'Die-cast Aluminum',
    module_width_mm: 200,
    module_height_mm: 112.5,
    color_temperature: '3200–9300K',
    curve: null,
    application: 'Retail / Corporate',
    spec_confidence: 0.87,
    spec_source: 'rule-engine',
    warnings: [],
  },
  {
    temp_id: 'demo-spec-008',
    model: 'INFiLED DB1.9',
    competitor: 'INFiLED',
    series: 'DB Series',
    pitch_mm: 1.95,
    led_type: 'SMD 1515',
    panel_width_mm: 600,
    panel_height_mm: 337.5,
    panel_depth_mm: 44,
    weight_kg: 6.8,
    max_power_w: 200,
    typical_power_w: 68,
    brightness: 1200,
    refresh_rate: 3840,
    ip_rating: 'IP30',
    viewing_angle: 'H160°/V160°',
    contrast_ratio: '8000:1',
    indoor_outdoor: 'Indoor',
    maintenance: 'Front/Rear',
    material: 'Die-cast Aluminum',
    module_width_mm: 200,
    module_height_mm: 112.5,
    color_temperature: '3200–9300K',
    curve: null,
    application: 'Meeting Room / Lobby',
    spec_confidence: 0.89,
    spec_source: 'rule-engine',
    warnings: [],
  },
];
